import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import cacheService from '../../services/cacheService';

/**
 * Componente que muestra un indicador cuando la aplicación está en modo offline
 */
const OfflineIndicator: React.FC = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const { t } = useTranslation();

  useEffect(() => {
    // Función para manejar cambios en el estado de conexión
    const handleConnectionChange = (isOnline: boolean) => {
      setIsOffline(!isOnline);
    };

    // Registrar el listener
    cacheService.addOfflineListener(handleConnectionChange);

    // Establecer estado inicial
    setIsOffline(!navigator.onLine);

    // Limpiar al desmontar
    return () => {
      cacheService.removeOfflineListener(handleConnectionChange);
    };
  }, []);

  // No mostrar nada si estamos en línea
  if (!isOffline) {
    return null;
  }

  return (
    <div 
      className="fixed bottom-4 left-0 right-0 mx-auto w-11/12 max-w-md bg-yellow-100 dark:bg-yellow-800 text-yellow-800 dark:text-yellow-100 px-4 py-3 rounded-lg shadow-lg flex items-center justify-between z-50"
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-center">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          className="h-5 w-5 mr-2" 
          viewBox="0 0 20 20" 
          fill="currentColor"
          aria-hidden="true"
        >
          <path 
            fillRule="evenodd" 
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" 
            clipRule="evenodd" 
          />
        </svg>
        <span>{t('common.offlineMode')}</span>
      </div>
      <span className="text-xs">{t('common.offlineDescription')}</span>
    </div>
  );
};

export default OfflineIndicator;
